import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as allActions from "./actions";

/**
 * Hook providing bound action creators for the rateCards Redux slice.
 * @returns {Object} Bound action creators: updateRateCards, updateRateCardsSearchForm, updateRateCardForm, clearRateCards, clearRateCardForm
 */
export function useRateCardsActions() {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch]);
}
